module.exports = __webpack_public_path__ + "static/media/Q_6.bd924f5b.jpg";